export default function () {
  const { locale } = useI18n();
  const language = computed(() => {
    return locale.value.startsWith('en') ? 'en' : 'es';
  });
  return { language };
}
